var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../../../service/api.service';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
var KtsImportTargetService = /** @class */ (function (_super) {
    __extends(KtsImportTargetService, _super);
    function KtsImportTargetService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        return _this;
    }
    KtsImportTargetService.prototype.getList = function (msg) {
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            options.push({ code: 'all', display: msg['au.COMPONENT.KtsImportTargetComponent.select.all'] });
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.id, display: item.name });
            }
            return options;
        }));
    };
    KtsImportTargetService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    KtsImportTargetService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return KtsImportTargetService;
}(ContentBaseService));
export { KtsImportTargetService };
var Target = /** @class */ (function () {
    function Target() {
    }
    return Target;
}());
export { Target };
//# sourceMappingURL=import-target.service.js.map